import { types } from 'mobx-state-tree';

export const PharmacyBase = types.model('PharmacyBase', {
  pharmacyId: types.identifierNumber,
  apbNumber: types.number,
  level: types.number,
  name: types.string,
  language: types.string,
  anchor: types.maybe(types.string),
  city: types.maybe(types.string),
  isActive: types.boolean,
});
